// $(document).ready(function () {
//   const $slider = $('.product-slider');
//   const $thumbs = $('.product-thumbs');

//   // Function to initialize sliders
//   function initSliders() {
//     // Main product slider
//     $slider.slick({
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       arrows: true,
//       fade: false,
//       infinite: false,
//       asNavFor: '.product-thumbs',
//       prevArrow: `
//         <button type="button" class="slick-prev custom-prev">
//           <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
//             <path d="M24 0C37.2378 0 48 10.7622 48 24C48 37.2378 37.2378 48 24 48C10.7622 48 0 37.2378 0 24C0 10.7622 10.7622 0 24 0ZM19.68 29.7853C19.2066 30.2623 18.941 30.907 18.941 31.5789C18.941 32.2509 19.2066 32.8956 19.68 33.3725C20.159 33.8421 20.803 34.1052 21.4737 34.1052C22.1445 34.1052 22.7885 33.8421 23.2674 33.3725L30.8464 25.7936C31.3198 25.3167 31.5854 24.672 31.5854 24C31.5854 23.328 31.3198 22.6833 30.8464 22.2064L23.2674 14.6275C23.0319 14.3919 22.7523 14.2051 22.4445 14.0776C22.1368 13.9501 21.8069 13.8845 21.4738 13.8844C21.1407 13.8844 20.8108 13.95 20.5031 14.0775C20.1953 14.205 19.9157 14.3918 19.6801 14.6273C19.4446 14.8629 19.2577 15.1425 19.1302 15.4503C19.0027 15.758 18.9371 16.0879 18.9371 16.421C18.9371 16.7541 19.0027 17.084 19.1302 17.3917C19.2576 17.6995 19.4445 17.9791 19.68 18.2147L25.4906 24L19.68 29.7853Z" fill="#1B354F"/>
//           </svg>
//         </button>
//       `,
//       nextArrow: `
//         <button type="button" class="slick-next custom-next">
//           <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
//             <path d="M24 0C37.2378 0 48 10.7622 48 24C48 37.2378 37.2378 48 24 48C10.7622 48 0 37.2378 0 24C0 10.7622 10.7622 0 24 0ZM19.68 29.7853C19.2066 30.2623 18.941 30.907 18.941 31.5789C18.941 32.2509 19.2066 32.8956 19.68 33.3725C20.159 33.8421 20.803 34.1052 21.4737 34.1052C22.1445 34.1052 22.7885 33.8421 23.2674 33.3725L30.8464 25.7936C31.3198 25.3167 31.5854 24.672 31.5854 24C31.5854 23.328 31.3198 22.6833 30.8464 22.2064L23.2674 14.6275C23.0319 14.3919 22.7523 14.2051 22.4445 14.0776C22.1368 13.9501 21.8069 13.8845 21.4738 13.8844C21.1407 13.8844 20.8108 13.95 20.5031 14.0775C20.1953 14.205 19.9157 14.3918 19.6801 14.6273C19.4446 14.8629 19.2577 15.1425 19.1302 15.4503C19.0027 15.758 18.9371 16.0879 18.9371 16.421C18.9371 16.7541 19.0027 17.084 19.1302 17.3917C19.2576 17.6995 19.4445 17.9791 19.68 18.2147L25.4906 24L19.68 29.7853Z" fill="#1B354F"/>
//           </svg>
//         </button>
//       `
//     });

//     // Thumbnail slider
//     $thumbs.slick({
//       slidesToShow: 5,
//       slidesToScroll: 1,
//       asNavFor: '.product-slider',
//       focusOnSelect: true,
//       vertical: true,
//       arrows: false,
//       infinite: false,
//       responsive: [
//         {
//           breakpoint: 768,
//           settings: {
//             vertical: false,
//             slidesToShow: 4
//           }
//         }
//       ]
//     });
//   }

//   // Initialize sliders on page load
//   initSliders();

//   // Reset transform when reaching first/last slide (this part is fine)
//   $slider.on('afterChange', function (event, slick, currentSlide) {
//     const $track = $thumbs.find('.slick-track');
//     $track.css('transform', 'none');
//   });

//   // Re-initialize sliders on window resize
//   $(window).on('resize', function() {
//     if ($thumbs.hasClass('slick-initialized')) {
//       $thumbs.slick('unslick');
//       $slider.slick('unslick');
//     }
//     initSliders();
//   });
// });



$(document).ready(function () {
  const openId = localStorage.getItem("openFaqId");

  // Expand smoothly
  function expandAnswer($answer) {
    $answer.css("max-height", $answer[0].scrollHeight + "px");
    $answer.css("padding", "0");
  }

  // Collapse smoothly
  function collapseAnswer($answer) {
    const fullHeight = $answer[0].scrollHeight;
    $answer.css("max-height", fullHeight + "px");
    $answer[0].offsetHeight; // force reflow
    $answer.css({
      "max-height": "0",
      "padding": "0"
    });
  }

  // Restore open FAQ
  if (openId) {
    const $item = $(`.custom-faq-item[data-id="${openId}"]`);
    const $answer = $item.find(".custom-faq-answer");
    if ($item.length && $answer.length) {
      $item.addClass("active");
      expandAnswer($answer);
    }
  }

  // Click toggle
  $(".custom-faq-question").on("click", function () {
    const $item = $(this).closest(".custom-faq-item");
    const $answer = $item.find(".custom-faq-answer");

    // Close all others
    $(".custom-faq-item").not($item).removeClass("active")
      .find(".custom-faq-answer").each(function () {
        collapseAnswer($(this));
      });

    if ($item.hasClass("active")) {
      // Close current
      $item.removeClass("active");
      collapseAnswer($answer);
      localStorage.removeItem("openFaqId");
    } else {
      // Open current
      $item.addClass("active");
      expandAnswer($answer);
      localStorage.setItem("openFaqId", $item.data("id"));

      // Wait a bit so open animation starts, then scroll smoothly
      setTimeout(() => {
        $("html, body").animate({
          scrollTop: $item.offset().top - 20
        }, 500);
      }, 150);
    }
  });

  // Recalculate if an image loads
  $(".custom-faq-answer img").on("load", function () {
    const $answer = $(this).closest(".custom-faq-answer");
    if ($answer.closest(".custom-faq-item").hasClass("active")) {
      expandAnswer($answer);
    }
  });
});





document.addEventListener("DOMContentLoaded", function() {
  if (window.innerWidth <= 749) {
    $('.section-familiar .row').slick({
      centerMode: true,
      centerPadding: '40px',
      slidesToShow: 1,
          prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-arrow-left' aria-hidden='true'></i></button>",
      nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-arrow-right' aria-hidden='true'></i></button>",
      arrows: false,
      dots: false,
      autoplay: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 749,
          settings: {
            centerMode: true,
            centerPadding: '90px',
            slidesToShow: 1
          }
        }
      ]
    });
  }
});





function openPopup() {
  document.getElementById("sizeGuidePopup").style.display = "flex";
}

function closePopup() {
  document.getElementById("sizeGuidePopup").style.display = "none";
}

function openTab(evt, tabName) {
  const tabs = document.querySelectorAll(".custom_size_guide .tab-content");
  const buttons = document.querySelectorAll(".custom_size_guide .tab-btn");

  tabs.forEach(tab => tab.classList.remove("active"));
  buttons.forEach(btn => btn.classList.remove("active"));

  document.getElementById(tabName).classList.add("active");
  evt.currentTarget.classList.add("active");
}

window.onclick = function(event) {
  const popup = document.getElementById("sizeGuidePopup");
  if (event.target === popup) {
    popup.style.display = "none";
  }
}


function addCart(id){
                let formData = {
                               id: id,
                               quantity: 1,
                  };
                $.ajax({
                   url: '/cart/add',
                   type: 'POST',
                   data: formData,
                  success: function(response){
                    $.ajax({
                      url: '/?section_id=cart-drawer',
                      type: 'GET',
                      dataType: 'html',
                      success: function(carthtml){
                         $('.drawer').addClass('animate active');
                         $('cart-drawer').html($(carthtml).find('cart-drawer').html());
                         bubbleUpdate();
                         $('cart-drawer').removeClass('is-empty');
                      }
                    })
                  }
                });
                    function bubbleUpdate() {
                      fetch(window.Shopify.routes.root + 'cart.js')
                             .then(response => response.json())
                             .then(data => {
                                 let c = data.item_count;
                              $('.cart-count-bubble').length
                                ? ($('.cart-count-bubble span[aria-hidden]').text(c),
                                  $('.cart-count-bubble .visually-hidden').text(c + ' items'))
                                : $('#cart-icon-bubble').append(
                                      `<div class="cart-count-bubble">
                                        <span aria-hidden="true">${c}</span>
                                        <span class="visually-hidden">${c} items</span>
                                      </div>`
                                  );

                               });
                       }
}









    const faqItems = document.querySelectorAll(".faq-item");

    faqItems.forEach(item => {
        const btn = item.querySelector(".faq-question");

        btn.addEventListener("click", () => {
            // close other items
            faqItems.forEach(i => {
                if (i !== item) {
                    i.classList.remove("active");
                    i.querySelector(".icon").textContent = "+";
                }
            });

            // toggle current item
            item.classList.toggle("active");

            const icon = item.querySelector(".icon");
            icon.textContent = item.classList.contains("active") ? "–" : "+";
        });
    });



      $(document).ready(function () {
        $('.testimonial-slider').slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            dots: true,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 3000,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                       centerMode: true,
            centerPadding: '90px',
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });


    